import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { checkAccessToken } from '@/utils/handle-authentication';
import { createProjectAction } from '@/redux/actions/project';
import { createProject, TCreateProjectResponse } from '@/services/api/project';
import { handleAPIError } from '@/utils/handle-api-error';

//  FUNCTION
export function* createProjectSaga(action: ActionType<typeof createProjectAction.request>): Generator {
  const { materials, companyId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(createProject, materials, companyId);
    const createProjectResponse: TCreateProjectResponse = response as TCreateProjectResponse;
    yield put(createProjectAction.success(createProjectResponse));
    successCallback?.(createProjectResponse);
  } catch (err) {
    yield put(createProjectAction.failure(err));
    failedCallback?.(err);
    handleAPIError(err, 'Error.createProjectError');
  }
}
